const getUsages = async (user_id) => {
  const domain = process.env.REACT_APP_SERVER;
  const url = `${domain}/user/user_usages/${user_id}`;
  const options = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  };

  const res = await fetch(url, options);
  if (res.status === 200) {
    const data = await res.json();
    return { data: data?.data, paymentHistory: data?.paymentHistory };
  } else {
    return {
      data: {
        current_plan: "Free",
        total_credits: 20,
        credits_limit: 0,
        create_expire: new Date(),
      },
      paymentHistory: [],
    };
  }
};

export default getUsages;
